import {
    TokenOperationFilters,
} from "../types/tokenOperations";

export const tokenOperationsEndpoints = {
    getTokenOperations: {
        query: (filters: TokenOperationFilters) => ({
            url: "/admin/token-operations",
            params: filters,
        }),
        providesTags: () => [{ type: "TokenOperations" as const, id: "LIST" }],
    },
    getTokenOperationsActions: {
        query: () => "/admin/token-operations/actions",
        providesTags: () => [{ type: "TokenOperations" as const, id: "ACTIONS" }],
    },
};

export const tokenOperationsTags = ["TokenOperations"] as const;

